import { useMemo } from "react";

const useLegalLinks = () => {
  const legalLinks = useMemo(() => {
    const currentDomain = window.location.hostname;

    if (currentDomain === "postpadi.com") {
      return {
        terms: "https://postpadi.com/terms-of-service",
        privacy: "https://postpadi.com/privacy-policy",
      };
    }

    return {
      terms: "https://postpaddy.com/pages/terms-of-service",
      privacy: "https://postpaddy.com/pages/privacy-policy",
    };
  }, []);

  return legalLinks;
};

export default useLegalLinks;
